import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import { Box, Container, Grid, Typography } from "@mui/material";
import { designTokens } from "../../../theme/designTokens";
import { whoWeAreContent } from "../../../theme/aboutContent";

const { colors, fonts, spacing } = designTokens;

const valueIcons = [
  <GroupsOutlinedIcon sx={{ fontSize: 48, color: colors.primary }} />,
  <HandshakeOutlinedIcon sx={{ fontSize: 48, color: colors.primary }} />,
  <StarOutlineOutlinedIcon sx={{ fontSize: 48, color: colors.primary }} />,
  <AutoGraphOutlinedIcon sx={{ fontSize: 48, color: colors.primary }} />,
];

const WhoWeAreSection = () => (
  <Box
    sx={{
      backgroundColor: "rgba(163,159,159,0.05)",
      py: { xs: 6, md: 8 },
    }}
  >
    <Container maxWidth={spacing.containerMax}>
      <Box sx={{ textAlign: "center", mb: { xs: 8, md: 10 } }}>
        <Typography
          sx={{
            color: colors.primary,
            fontWeight: 900,
            fontSize: "1.25rem",
            lineHeight: "30px",
            mb: 2,
          }}
        >
          {whoWeAreContent.label}
        </Typography>
        <Typography
          component="h2"
          sx={{
            fontWeight: 900,
            fontSize: { xs: "1.75rem", md: "2.5rem" },
            lineHeight: "30px",
            color: colors.textPrimary,
            mb: 2,
          }}
        >
          {whoWeAreContent.title}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "1rem", md: "1.25rem" },
            lineHeight: { xs: 1.7, md: "38px" },
            color: colors.textPrimary,
            maxWidth: 1120,
            mx: "auto",
          }}
        >
          {whoWeAreContent.subtitle}
        </Typography>
      </Box>

      <Grid container spacing={{ xs: 6, md: 3 }} justifyContent="center">
        {whoWeAreContent.values.map((value, index) => (
          <Grid item xs={12} sm={6} md={3} key={value.title}>
            <Box sx={{ position: "relative", pt: 5 }}>
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 94,
                  height: 91,
                  borderRadius: "50%",
                  backgroundColor: colors.white,
                  boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 2,
                }}
              >
                {valueIcons[index]}
              </Box>

              <Box
                sx={{
                  backgroundColor: colors.white,
                  borderRadius: "10px",
                  boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                  pt: 7,
                  pb: 3,
                  px: 2,
                  minHeight: 233,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: fonts.weights.bold,
                    fontSize: "1.25rem",
                    lineHeight: "30px",
                    color: colors.textPrimary,
                    mb: 1,
                  }}
                >
                  {value.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    lineHeight: "30px",
                    color: colors.textPrimary,
                  }}
                >
                  {value.description}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default WhoWeAreSection;
